import {lazy} from "react";

export const AutoTrackingLazy = lazy(() => import('./AutoTracking'))